<template>
  <AuthShell>
    <div class="auth-form">
      <template v-if="loading">
        <h1 class="auth-form__title">Confirming your email</h1>
        <p class="auth-form__sub">One moment.</p>
      </template>

      <template v-else-if="failure">
        <h1 class="auth-form__title">We couldn't confirm that link</h1>
        <p class="auth-form__sub">The link may have expired or already been used. Ask your admin to resend it.</p>
        <v-alert v-if="errors.length > 0" type="error" variant="tonal">
          <div v-for="error in errors" :key="error">{{ error }}</div>
        </v-alert>
        <v-btn color="primary" block size="large" @click="redirectionToLoginPage">Go to sign in</v-btn>
      </template>

      <template v-else>
        <h1 class="auth-form__title">Account registered</h1>
        <p class="auth-form__sub">Your email is confirmed. Sign in to get started.</p>
        <v-btn color="primary" block size="large" @click="redirectionToLoginPage">Continue to sign in</v-btn>
      </template>
    </div>
  </AuthShell>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import authService from "@/services/authService";
import { tryParseApiErrors } from "@/utils";
import AuthShell from "@/components/AuthShell.vue";

const loading = ref(true);
const failure = ref(false);
const route = useRoute();
const router = useRouter();
const errors = ref([]);

onMounted(async () => {
  try {
    await authService.confirmEmail(route.params.user_id, route.params.token);
  } catch (error) {
    errors.value = tryParseApiErrors(error);
    failure.value = true;
  }
  loading.value = false;
});

function redirectionToLoginPage() {
  router.push({ name: "login" });
}
</script>

<style lang="scss" scoped>
@import "@/styles/pages/_auth-form.scss";
</style>
